import { render } from "./CabinetTable.vue?vue&type=template&id=0e211733&scoped=true&ts=true"
import script from "./CabinetTable.ts?vue&type=script&lang=ts"
export * from "./CabinetTable.ts?vue&type=script&lang=ts"

import "./CabinetTable.scss?vue&type=style&index=0&id=0e211733&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e211733"]])

export default __exports__